import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import SkeletonLoader from '../../components/SkeletonLoader';
import { listProses } from '../../Api';

// Function to parse Indonesian date format (dd-MMM-yyyy) into JavaScript Date
const parseDateWithIndonesianMonth = (dateString) => {
  const months = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    Mei: "05",
    Jun: "06",
    Jul: "07",
    Agu: "08",
    Sep: "09",
    Okt: "10",
    Nov: "11",
    Des: "12",
  };

  const [day, month, year] = dateString.split("-");
  const normalizedMonth = months[month];
  if (!normalizedMonth) return null;

  return new Date(`${year}-${normalizedMonth}-${day}`);
};

function Proses({ dateRange }) {
  const [proses, setProses] = useState(null);
  const [filteredProses, setFilteredProses] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchOnceRef = useRef(false);
  const navigate = useNavigate();

  const fetchProses = async () => {
    setLoading(true);
    try {
      const data = await listProses();
      setProses(data);
    } catch (err) {
      setError('Failed to fetch Proses Pengerjaan data');
    } finally {
      setLoading(false);
    }
  };

  const filterHistory = () => {
    if (!proses) return;

    if (!dateRange) {
      setFilteredProses(proses);
      return;
    }

    const today = new Date();
    const pastDate = new Date();
    pastDate.setDate(today.getDate() - dateRange);

    const filtered = {};
    Object.keys(proses).forEach((monthYear) => {
      const filteredItems = proses[monthYear].filter((item) => {
        const itemDate = parseDateWithIndonesianMonth(item.tgl_pengiriman);
        return (
          itemDate &&
          itemDate >= pastDate &&
          itemDate <= today
        );
      });

      if (filteredItems.length > 0) {
        filtered[monthYear] = filteredItems;
      }
    });

    setFilteredProses(filtered);
  };

  useEffect(() => {
    if (fetchOnceRef.current) return;
    fetchOnceRef.current = true;
    fetchProses();
  }, []);

  useEffect(() => {
    filterHistory();
  }, [proses, dateRange]);

  const handleItemClick = (item) => {
    navigate(`/detailproses/${item.id}`, { state: { item } });
  };

  return (
    <div className="historypage">
      {loading ? (
        <div>
          <SkeletonLoader count={3} height={50} />
          <SkeletonLoader count={5} height={30} />
        </div>
      ) : error ? (
        <p>{error}</p>
      ) : filteredProses && Object.keys(filteredProses).length === 0 ? (
        <p className="infotext">Anda Belum memiliki Proses Pengerjaan data</p>
      ) : (
        filteredProses &&
        Object.keys(filteredProses).map((monthYear) => (
          <div key={monthYear} className="history-group" >
            <h3 className="month-header">{monthYear}</h3>
            <div className="item-list" style={{cursor:'pointer'}}>
              {filteredProses[monthYear].map((item, index) => (
                <div
                  key={`${item.id}-${index}`}
                  className="item"
                  onClick={() => handleItemClick(item)}
                >
                  <div className="item-date">
                    <span className="item-day">
                      {item.tgl_pengiriman.split('-')[0]}
                    </span>
                    <span className="item-month">
                      {item.tgl_pengiriman.split('-')[1]}
                    </span>
                    <span className="item-year">
                      {item.tgl_pengiriman.split('-')[2]}
                    </span>
                  </div>
                  <div className="item-content">
                    <h3 className="item-title">{item.nama_instalasi}</h3>
                    <p className="item-description">Surat Jalan : {item.no_surat_jln}</p>
                  </div>
                  <div className="item-status">
                    <span
                      className={
                        item.status_proses === 'Completed'
                          ? 'status-green'
                          : item.status === 'On Process'
                          ? 'status-grey'
                          : 'status-red'
                      }
                    >
                      {item.status_proses}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default Proses;
